<template>
    <div class="d-flex w-100 flex-grow-1 bg-dark">
        <div class="d-flex flex-column bg-blur-dark">
            <div class="p-3 bg-blur-darker text-center">
                <h4 class="text-white mb-0">{{ $t('js.backend.live.slide_navigation') }}</h4>

            </div>
            <button v-if="activeSlide" @click.prevent="putStopLive" :disabled="navigationDisabled" class="btn btn-sm btn-danger rounded-0"><i class="fas fa-video-slash mr-2"></i> {{ $t('js.backend.live.stop_live') }}</button>
            <div class="d-flex flex-grow-1 p-2 flex-column pretty-scroll-theme" style="overflow-y: auto; height: 0">
                <SlideNavigation v-for="slide in slides" :key="slide.id" :slide="slide" :active="activeSlide && slide.id === activeSlide.id" :disabled="navigationDisabled" @goToSlide="putGoToSlide"/>
            </div>
        </div>
        <div class="d-flex flex-column flex-grow-1" style="width: 1px">
            <div v-if="activeSlide" class="d-flex flex-column flex-grow-1 overflow-auto" style="height:0; min-height: 350px">
                <SlideShow v-if="election" :election="election" :showVoterCounts="false" class="flex-grow-1 pretty-scroll-theme" style="height: 100%; width: unset; overflow: visible !important; overflow-y: auto" :showLocaleSwitcher="false"></SlideShow>

                <div class="bg-dark p-0">
                    <div class="d-flex justify-content-between">
                        <button @click.prevent="putGoToPrevious" class="btn btn-secondary col-sm-3 rounded-0" :disabled="!previousSlide || navigationDisabled"><i class="fa fa-chevron-left"></i> <span class="d-sm-inline d-none">{{ $t('js.actions.previous') }}</span></button>
                        <template v-if="isBallot">
                            <div class="d-flex col-sm-6 col-8 p-0">
                                <button v-if="ballotStateIn('new')" :disabled="readonly" class="btn btn-success rounded-0 col" @click.prevent="putOpenBallot">{{ $t('js.actions.open') }}</button>
                                <div v-if="ballotStateIn('countdown')" class="d-flex border-warning bg-light border justify-content-end col-9 p-0">
                                    <div class="btn disabled col">
                                        <span>{{ $t('js.backend.live.closing') }}</span>
                                        <Countdown v-if="activeSlide.disableAt" :end-time="activeSlide.disableAt"/>
                                    </div>
                                    <button type="button" @click.prevent="putExtendCloseBallot(30)" :disabled="readonly" class="btn btn-secondary rounded-0 col-auto">+30s</button>
                                    <button type="button" @click.prevent="putCancelCloseBallot()" :disabled="readonly" class="btn btn-warning rounded-0 col-auto"><span class="fas fa-times"></span></button>
                                </div>
                                <template v-if="ballotStateIn('open')">
                                  <div class="btn-group col-6 px-0" key="close">
                                    <button type="button" class="rounded-0 btn btn-warning" @click.prevent="putCloseBallot(60)" :disabled="readonly">
                                      <i class="fas fa-lock"></i> <span>{{ $tc('js.backend.live.close_in_n_minutes', 1) }}</span>
                                    </button>
                                    <button type="button" class="rounded-0 btn btn-warning dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"  :disabled="readonly">
                                        <span class="sr-only">{{ $t('js.actions.close') }}</span>
                                    </button>
                                    <div class="dropdown-menu" id="closeBallotDropdown">
                                        <button class="dropdown-item" @click.prevent="putCloseBallot(0)">{{ $t('js.backend.live.close_now') }}</button>
                                        <button class="dropdown-item" @click.prevent="putCloseBallot(60)">{{ $tc('js.backend.live.close_in_n_minutes', 1) }}</button>
                                        <button class="dropdown-item" @click.prevent="putCloseBallot(180)">{{ $tc('js.backend.live.close_in_n_minutes', 3) }}</button>
                                        <button class="dropdown-item" data-toggle="modal" data-target="#promptModal">{{ $t('js.backend.live.close_in') }}</button>
                                    </div>
                                  </div>
                                </template>
                                <template v-if="ballotStateIn('closed')">
                                    <button class="btn btn-warning rounded-0 col-3" @click.prevent="putOpenBallot" key="reopen" :disabled="readonly"><i class="fas fa-unlock-alt"></i> <span class="d-none d-md-inline">{{ $t('js.actions.open') }}</span></button>
                                    <button :disabled="activeSlide.voteCount === 0 || readonly" class="btn btn-success dropdown-toggle rounded-0 col-6" key="calculate" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" >{{activeSlide.voteCount > 0 ? $t('js.actions.calculate') : $t('js.backend.live.no_votes_submitted')}}</button>
                                    <div class="dropdown-menu" id="resultDropdown">
                                        <button class="dropdown-item" @click.prevent="putCalculateResult(false)">{{ $t('js.actions.calculate_private') }}</button>
                                        <button class="dropdown-item" @click.prevent="putCalculateResult(true)">{{ $t('js.actions.calculate_public') }}</button>
                                    </div>
                                </template>
                                <template v-if="ballotStateIn('calculating_result')">
                                    <button class="btn btn-warning rounded-0 col" @click.prevent="putCancelBallot" :disabled="readonly"><i class="fas fa-times"></i> <span class="d-none d-md-inline">{{ $t('js.actions.cancel') }}</span></button>
                                </template>
                                <button v-if="ballotStateIn('finished') && activeSlide.result && !activeSlide.result.publicised" :disabled="readonly" class="btn btn-success col rounded-0" @click.prevent="putMakeResultPublic">{{ $t('js.backend.live.make_public') }}</button>
                                <button v-show="!ballotStateIn(['new', 'calculating_result'])" class="btn btn-danger col rounded-0" :disabled="readonly" data-toggle="modal" data-target="#resetOuter"><i class="fas fa-history"></i> <span class="d-none d-md-inline">{{ ballotStateIn('open') ? $t('js.backend.live.close_and_reset') : $t('js.actions.reset') }}</span></button>
                            </div>

                        </template>
                        <button @click.prevent="putGoToNext" class="btn btn-secondary rounded-0 col-sm-3" :disabled="!nextSlide || navigationDisabled"> <span class="d-sm-inline d-none">{{ $t('js.actions.next') }}</span> <i class="fa fa-chevron-right"></i></button>
                    </div>
                </div>

            </div>
            <div v-else class="d-flex flex-column justify-content-center flex-grow-1" style="height:0; min-height: 400px; background: rgba(0,0,0,0.5)">
                <div class="text-center text-white p-2">
                    <h3>{{ $t('js.slide_show.no_slide_active') }}</h3>
                </div>
            </div>
            <router-view class="bg-dark"/>
        </div>

        <ResetModal @resetBallot="putResetBallot" :id="'resetOuter'"/>
        <PromptModal :message="$t('js.backend.live.set_seconds_until_ballot_close')" @submit="putCloseBallot"/>

      <ToastManager style="z-index: 5; position: absolute; left: 0; right: 0; top: 0; bottom: 0" placement="center center" class="mb-3 ml-3"/>
    </div>
</template>
<script>
    import PreviewSlide from "./PreviewSlide"
    import {mapGetters, mapState} from "vuex"
    import SlideNavigation from "./SlideNavigation"
    import apiClient from "../../packs/frontend/apiClient"
    import SlideShow from "../frontend/observer/SlideShow"
    import Countdown from "../frontend/shared/Countdown";
    import ResetModal from "./ResetModal"
    import PromptModal from "./PromptModal";
    import Results from "./Results"
    import ToastManager from "../shared/toasts/ToastManager";

    export default {
        name: 'PresentationControl',
        components: {ToastManager, Results, PromptModal, Countdown, ResetModal, SlideShow, SlideNavigation, PreviewSlide},

        computed: {
            ...mapState(['election', 'slides', 'readonly']),
            ...mapGetters(['activeSlide', "firstAvailableLocale"]),
            navigationDisabled(){
                return (this.isBallot && this.ballotStateIn(['open','countdown'])) || this.readonly
            },
            nextSlide(){
                return this.slides.filter(s => s.position === this.activeSlide.position+1)[0]
            },
            previousSlide(){
                return this.slides.filter(s => s.position === this.activeSlide.position-1)[0]
            },
            isBallot(){
                return this.activeSlide && this.activeSlide.type === 'Slides::BallotSlide'
            }
        },
        methods:{
            ballotStateIn(ballotStates) {
                if(this.isBallot){
                    if(Array.isArray(ballotStates)){
                        return ballotStates.includes(this.activeSlide.state)
                    } else {
                        return ballotStates === this.activeSlide.state
                    }
                }
                return false
            },
            putGoToNext(){
                if(this.nextSlide){
                    this.putGoToSlide(this.nextSlide.id)
                }
            },
            putGoToPrevious(){
                if(this.previousSlide){
                    this.putGoToSlide(this.previousSlide.id)
                }
            },
            putGoToSlide(id){
                if((this.activeSlide && id === this.activeSlide.id) || this.navigationDisabled){
                    return
                }
                apiClient.put(id+'/goto')
            },
            putOpenBallot(){
                apiClient.put(this.activeSlide.id+'/activate')
            },
            putCloseBallot(offset = 0){
                if(typeof offset !== Number) offset = Number.parseInt(offset)
                apiClient.put(this.activeSlide.id+'/close', {time_offset: offset})
            },
            putCancelCloseBallot(){
                apiClient.put(this.activeSlide.id+'/cancel')
            },
            putExtendCloseBallot(offset = 30){
                apiClient.put(this.activeSlide.id+'/extend', {time_offset: offset})
            },
            putResetBallot(){
                apiClient.put(this.activeSlide.id+'/reset')
            },
            putCalculateResult(asPublic = true){
                apiClient.put(this.activeSlide.id+'/calculate', {publicised: asPublic})
            },
            putMakeResultPublic(){
                apiClient.put(this.activeSlide.id+'/make_public')
            },
            putCancelBallot(){
                apiClient.put(this.activeSlide.id+'/cancel')
            },
            putGoLive(){
                apiClient.put(this.slides[0].id+'/goto')
            },
            putStopLive(){
                apiClient.put('stop_live')
            }
        }
    }
</script>
